<div class="list-of-members">
  @for (items of filteredUsers$ | async; track items) {
  <div>
    <div class="letter">{{ items.letter }}</div>
    <mat-divider></mat-divider>
    <div class="members" [ngStyle]="{ columns: columnCount }">
      @for (item of items.data; track item; let i = $index) {
      <div class="member">
        <mat-checkbox
          color="primary"
          [disabled]="
            !!maxItemCount &&
            formControl.value.length >= maxItemCount &&
            (formControl.value | invokeFunction : isCheckedUser : item)
          "
          (change)="selectMember($event, item)"
          [checked]="formControl.value | invokeFunction : isCheckedUser : item"
          [attr.data-cy]="E2eLocators.ADMIN_SELECT_USERS_LIST_ITEM"
        >
          <mat-label>{{ item.name }}</mat-label>
        </mat-checkbox>
      </div>
      }
    </div>
  </div>
  }
</div>
